import { render, staticRenderFns } from "./DeliverHomeAdd.vue?vue&type=template&id=b2979a92&scoped=true"
import script from "./DeliverHomeAdd.vue?vue&type=script&lang=js"
export * from "./DeliverHomeAdd.vue?vue&type=script&lang=js"
import style0 from "./DeliverHomeAdd.vue?vue&type=style&index=0&id=b2979a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2979a92",
  null
  
)

export default component.exports